<template>
  <div class="register-status pos-relative fullheight">
    <Spin size="small" fix v-if="isLoading"></Spin>
    <Card style="width:400px" class="centered" v-else>
        <div style="text-align:center;padding:50px 20px" :style="{background: (invalid)? '#c5c8ce':'#19be6b'}">
          <Icon v-if="invalid" type="ios-alert-outline" size="100" color="#ffffff"/>
          <Icon v-else type="md-checkmark-circle-outline" size="100" color="#ffffff"/>
        </div>
        <div style="text-align:center;padding:50px 20px">
          <div v-if="invalid">
            <h2>{{ invalid }}</h2>
          </div>
          <div v-else>
            <h2>Registration approved successfully!</h2>
            <p class="padding-t-20">User registration has been confirmed.</p>
          </div>
        </div>
    </Card>
  </div>
</template>

<script>
import { approveRegistration } from '@/services/auth'

export default {
  data () {
    return {
      isLoading: false,
      invalid: null
    }
  },

  mounted () {
    this.approveRegistration()
  },

  methods: {
    approveRegistration () {
      this.isLoading = true
      approveRegistration(this.$route.params.email).then(res => {
        this.isLoading = false
      }).catch(err => {
        console.log('Failed to approved user registration: ', err)
        if (err.response.data && err.response.data.message) {
          this.$Message.error(err.response.data.message)
          this.invalid = err.response.data.message
        }
        this.isLoading = false
      })
    }
  }
}
</script>

<style lang="scss">
.register-status {
  .ivu-card {
    overflow: hidden;
    .ivu-card-body {
      padding: 0px;
    }
  }
}
</style>
